<template>
    <UDropdown :items="items" :popper="{ placement: 'bottom-end' }">
        <div class="flex items-center gap-2">
            <UButton icon="i-solar-user-rounded-line-duotone" size="xl" variant="ghost" color="gray" :padded="false" />
        </div>
        <template #credit="{ item }">
            <div class="w-full flex justify-between" v-if="!isUndefined(user?.data.wallet?.balance)">
                <div class="flex gap-2 items-center">
                    <UIcon :name="item.icon" class="w-5 h-5 text-gray-400" />
                    <UiComponentTypography> اعتبار </UiComponentTypography>
                </div>
                <UiComponentTypography>
                    {{ commaNumber(user.data.wallet.balance, { currencySymbol: "تومان" }) }}
                </UiComponentTypography>
            </div>
        </template>
    </UDropdown>
</template>

<script lang="ts" setup>
import type { IResponse } from "~/libs/types/api/pagination";
import type { IUser } from "~/libs/types/api/user";

const { logout } = useSanctumAuth();

const { t } = useI18n();

const user = useSanctumUser<IResponse<IUser>>();

const items = [
    [
        {
            label: user.value?.data.name ?? t("dear_user"),
            avatar: {
                src: getImageUrl(user.value?.data.profile?.avatar, "avatar"),
            },
            click: async () => {
                navigateTo("/dashboard");
            },
        },
    ],
    [
        {
            label: "اعتبار",
            slot: "credit",
            icon: "i-solar-wallet-money-line-duotone",
            click: async () => {
                navigateTo("/dashboard/wallet");
            },
        },
    ],
    [
        {
            label: "سفارش‌های من",
            icon: "i-solar-checklist-line-duotone",
            click: async () => {
                navigateTo("/dashboard/orders");
            },
        },
        {
            label: "آدرس‌های من",
            icon: "i-solar-map-line-duotone",
            click: async () => {
                navigateTo("/dashboard/addresses");
            },
        },
    ],
    [
        {
            label: "خروج",
            icon: "i-solar-logout-3-line-duotone",
            click: async () => {
                await logout();
            },
        },
    ],
];
</script>

<style></style>
